import { createActionGroup, props } from "@ngrx/store";
import { CreateQuote, Quote } from "src/api-service";
import { AppError } from "../../../app-store-error.types";

// **************************************************************************
// QUOTE CREATE ACTIONS - Creating new quotes (regular and subscription)
// Used in: /home/create-quote/, /home/create-subscription/
// **************************************************************************
export const QuoteCreateActions = createActionGroup({
    source: "Quote Create",
    events: {
        "Create": props<{ request: CreateQuote }>(),
        "Create Success": props<{ newQuoteId: number; companyId: string; toastKey: string }>(),
        "Create Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
